import React, { useCallback, useEffect, useState } from 'react';
import DspxModal from '../../common/DspxModal/DspxModal';
import {
  Button,
  Checkbox,
  Form,
  Icon,
  Radio,
  Select,
  Spin,
  Tooltip,
} from 'antd';
import { AddressesList } from '../AddressesRegistrationForm/AddressesRegistrationForm';
import { generateAddress } from '../../../utils/generateAddress';
import useChangeTemplateModalVisible from '../../../hooks/useChangeTemplateModalVisible';
import styles from './TemplateModal.module.scss';
import { useHouseRegistrationTypes } from '../HouseRegistrationTypeManager/api/registrationTypesQuery';
import { useChangeRegistrationType } from '../HouseRegistrationTypeManager/api/changeRegistrationType';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { registrationTypes } from '../../../constants/registrationTypes';
import { useSelector } from 'react-redux';
import { useChangeRegistrationTypesHouses } from '../HouseRegistrationTypeManager/api/changeRegistrationTypesHouses';
import HousesList from '../../common/HousesList/HousesList';
import { useArrearTypes } from '../HouseRegistrationTypeManager/api/arrearTypesQuery';
import useAccountTypes from '../../../queries/useAccountTypes';
import { getUniqueArrearProviders } from '../../../utils/getUniqueArrearProviders';
import TypeBlock from './components/TypeBlock/TypeBlock';
import { useArrearInfo } from '../HouseRegistrationTypeManager/api/arrearInfoQuery';
import { getHouseAndRoomCounts } from '../../../utils/getHouseAndRoomCounts';

const { Option } = Select;
const { Item } = Form;

const TemplateFormModal = ({ form, houseData }) => {
  const { getFieldDecorator, validateFields } = form;

  const history = useHistory();
  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const isArray = Array.isArray(houseData);
  const isObject =
    !isArray && typeof houseData === 'object' && houseData !== null;

  const houseIds = isArray
    ? houseData.map((item) => item.houseId)
    : [houseData?.houseId];

  const initialRegistrationType = isObject
    ? houseData?.registrationType
    : registrationTypes.open;

  const [isChecked, setIsChecked] = useState(false);
  const [stateType, setStateType] = useState(initialRegistrationType);
  const [lsStape, setLsStape] = useState(false); //выбран ли ЛС для изменения регситрации
  const [availableTypesLs, setAvailableTypesLs] = useState([]); // доступные типы для регистрации ЛС по домам
  const [lsTypesSelected, setLsTypesSelected] = useState([]); //финальный массив выбранных id типов ЛС для регистрации
  // const [accountTypeIds, setActiveLsTypes] = useState([]);
  // const [arrearProviders, setArrearProviders] = useState([]);
  // const [oversProvider, setOversProvider] = useState([]);

  const { close } = useChangeTemplateModalVisible();
  const { changeAsync: changeAsyncOnse, loading: loadingChengeType } =
    useChangeRegistrationType();
  const { changeAsync: changeAsyncAll, loading: loadingChengeTypes } =
    useChangeRegistrationTypesHouses();
  const { data: types } = useHouseRegistrationTypes({
    staleTime: Infinity,
    select: (data) => data.registrationTypes,
  });
  const { data: arrearTypes, isFetching: isFetchingArrearTypes } =
    useArrearTypes(
      {
        houseIds,
      },
      {
        enabled: lsStape,
      }
    );

  const { data: arrearInfo, isFetching: isFetchingArrearInfo } = useArrearInfo(
    {
      houseIds,
    },
    {
      enabled: lsStape,
    }
  );

  const { data: accountTypes, isFetchingAccount } = useAccountTypes({
    enabled: lsStape,
  });

  const registrationTypeClose = stateType?.id === registrationTypes.closed.id;
  const registrationTypePersonalAccounts =
    stateType?.id === registrationTypes.personalAccounts.id;
  const isFinalRegistrationState =
    registrationTypeClose || (registrationTypePersonalAccounts && lsStape);
  const requiresLsStep = registrationTypePersonalAccounts && !lsStape;
  const isClosedOrPersonalAccounts =
    registrationTypeClose || registrationTypePersonalAccounts;
  const fetchingLS =
    isFetchingArrearTypes || isFetchingArrearInfo || isFetchingAccount;
  const hasArrearInfo = arrearInfo && arrearInfo.length > 0;
  const housesPayload = isArray ? houseData : undefined;

  const address = isObject && generateAddress(houseData);

  const path = isArray
    ? `/HousingStock/company/${currentCompany?.id}/changingAllTwo`
    : `/HousingStock/company/${currentCompany?.id}/changing/${houseData?.houseId}`;

  // const findAccountTypeNameById = (id) => {
  //   const accountType = accountTypes.find(
  //     (accountType) => accountType.id === id
  //   );
  //   return accountType ? accountType.name : 'Тип неопределен';
  // };

  // const handleAccountTypeChange = (accountTypeId) => {
  //   const isSelected = accountTypeIds.includes(accountTypeId);
  //   if (isSelected) {
  //     setActiveLsTypes(accountTypeIds.filter((id) => id !== accountTypeId));
  //     setArrearProviders(
  //       arrearProviders.filter((p) => p.accountTypeId !== accountTypeId)
  //     );
  //   } else {
  //     setActiveLsTypes([...accountTypeIds, accountTypeId]);
  //     const newProviders = oversProvider.filter(
  //       (p) => p.accountTypeId === accountTypeId
  //     );
  //     const uniqueProviders = newProviders.filter(
  //       (p) => !arrearProviders.some((existing) => existing.id === p.id)
  //     );
  //     setArrearProviders([...arrearProviders, ...uniqueProviders]);
  //   }
  // };

  // const handleProviderChange = (provider) => {
  //   const isSelected = arrearProviders.some((p) => p.id === provider.id);
  //   if (isSelected) {
  //     const updatedProviders = arrearProviders.filter(
  //       (p) => p.id !== provider.id
  //     );
  //     setArrearProviders(updatedProviders);

  //     const stillHasType = updatedProviders.some(
  //       (p) => p.accountTypeId === provider.accountTypeId
  //     );
  //     if (!stillHasType) {
  //       setActiveLsTypes(
  //         accountTypeIds.filter((id) => id !== provider.accountTypeId)
  //       );
  //     }
  //   } else {
  //     setArrearProviders([...arrearProviders, provider]);

  //     if (!accountTypeIds.includes(provider.accountTypeId)) {
  //       setActiveLsTypes([...accountTypeIds, provider.accountTypeId]);
  //     }
  //   }
  // };

  const getInitialLsTypeValues = useCallback(() => {
    const initialLsTypeValues = [];

    if (arrearTypes && arrearTypes.length) {
      arrearTypes.forEach((type) => {
        const hasAvailableType = accountTypes.some(
          (item) => item.id === type.accountTypeId
        );

        if (hasAvailableType) {
          initialLsTypeValues.push(type.accountTypeId);
          return;
        }
      });
    }
    return initialLsTypeValues;
  }, [arrearTypes, accountTypes]);

  const getDeterminingNumberHouses = (id) => {
    let countStr = '';
    const result = availableTypesLs.find((type) => type.arrearTypeId === id);
    if (result) {
      countStr = getHouseAndRoomCounts(
        isArray ? result.houseCount : 0,
        result.flatCount
      );
    }
    return countStr;
  };

  const handleChangeType = (e) => {
    const result = Object.values(types).find((item) => item.id === e);
    setStateType(result);
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const navigateWithLsSelection = () => {
    setIsChecked(false);
    setLsStape(false);
    close();

    history.push(path, {
      houses: housesPayload,
      registrationType: stateType,
      activeLsTypes: lsTypesSelected,
    });
  };

  const submitWithoutLsStep = async () => {
    if (isArray) {
      await changeAsyncAll({
        housesArray: houseData,
        registrationType: stateType,
        HouseAccessTypeId: 0,
      });
    }
    if (isObject) {
      await changeAsyncOnse({
        houseId: houseData?.houseId,
        registrationType: stateType,
        templateId: 0,
      });
    }
    setIsChecked(false);
    setLsStape(false);
    close();
    if (isArray) {
      history.goBack();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields(async (err, values) => {
      if (err) {
        return;
      }

      if (types) {
        if (isFinalRegistrationState) {
          navigateWithLsSelection();
        } else if (requiresLsStep) {
          setLsStape(true);
        } else {
          await submitWithoutLsStep();
        }
      }
    });
  };

  const handleCancel = () => {
    setIsChecked(false);
    close();
  };

  const handleLsTypesChange = (checkedValues) => {
    setLsTypesSelected(checkedValues);
  };

  const disableFun = () => {
    return !isChecked || (lsTypesSelected.length === 0 && lsStape);
  };

  // styles
  const buttonStyle = disableFun()
    ? {
        backgroundColor: '#0995ED',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        opacity: '0.5',
      }
    : {
        backgroundColor: '#0995ED',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
      };

  const buttoCanselStyle = {
    borderRadius: '8px',
    color: '#0995ED',
    backgroundColor: 'white',
    border: '1px solid #0995ED',
  };

  const checkBosStyle = {
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    fontSize: '14px',
    fontWeight: '500',
    color: 'black',
  };

  // useEffect(() => {
  //   if (arrearTypes && arrearTypes.length > 0) {
  //     let overProvider = arrearTypes.reduce((acc, type) => {
  //       return acc.concat(getUniqueArrearProviders(type));
  //     }, []);

  //     const uniqueProviders = Array.from(
  //       new Map(overProvider.map((item) => [item.id, item])).values()
  //     );

  //     setOversProvider(uniqueProviders);
  //   }
  // }, [arrearTypes]);

  useEffect(() => {
    const initial = getInitialLsTypeValues();
    const isDifferent =
      initial.length !== lsTypesSelected.length ||
      initial.some((val, i) => val !== lsTypesSelected[i]);

    if (isDifferent) {
      setLsTypesSelected(initial);
    }
  }, [arrearTypes, accountTypes, getInitialLsTypeValues]);

  useEffect(() => {
    if (!hasArrearInfo) return;

    const map = new Map();

    arrearInfo.forEach((house) => {
      house.arrearInfo.forEach((type) => {
        const existing = map.get(type.arrearTypeId);
        if (existing) {
          existing.houseCount += 1;
          existing.flatCount += type.flatCount;
        } else {
          map.set(type.arrearTypeId, {
            houseCount: 1,
            flatCount: type.flatCount,
            arrearTypeId: type.arrearTypeId,
            arrearTypeName: type.arrearTypeName,
          });
        }
      });
    });

    const result = Array.from(map.values());
    setAvailableTypesLs(result);
  }, [arrearInfo, hasArrearInfo]);

  return (
    <DspxModal
      classModalRegistration="modalRegistration"
      visible={Boolean(houseData)}
      title="Изменить режим регистрации"
      onCancel={handleCancel}
      {...(lsStape
        ? {
            footer: [
              <div
                style={{ display: 'flex', justifyContent: 'space-between' }}
                key="footer"
              >
                <div>
                  <Tooltip
                    key="backTooltip"
                    title="Вернуться на предыдущий шаг"
                  >
                    <Button
                      onClick={() => setLsStape(false)}
                      className={styles.btnSave}
                      key="back"
                      style={{
                        backgroundColor: '#0995ED',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                      }}
                    >
                      Назад
                    </Button>
                  </Tooltip>
                  <Button
                    className={styles.btnSave}
                    key="cancel"
                    onClick={handleCancel}
                    style={buttoCanselStyle}
                  >
                    Отмена
                  </Button>
                </div>
                <Button
                  key="submit"
                  type="primary"
                  onClick={handleSubmit}
                  disabled={disableFun()}
                  loading={loadingChengeType || loadingChengeTypes}
                  className={styles.btnSave}
                  style={buttonStyle}
                >
                  {isClosedOrPersonalAccounts
                    ? 'Сохранить и продолжить'
                    : 'Сохранить'}
                </Button>
              </div>,
            ],
          }
        : {
            okText: isClosedOrPersonalAccounts
              ? 'Сохранить и продолжить'
              : 'Сохранить',
            onOk: handleSubmit,
            okButtonProps: {
              disabled: disableFun(),
              style: buttonStyle,
              loading: loadingChengeType,
              className: styles.btnSave,
            },
            cancelButtonProps: {
              style: buttoCanselStyle,
              className: styles.btnSave,
            },
          })}
    >
      {fetchingLS ? (
        <Spin
          style={{ marginLeft: '200px' }}
          tip="Загрузка доступных типов ЛС..."
        />
      ) : (
        <>
          {!lsStape && isObject && (
            <AddressesList
              company={houseData}
              address={address}
            />
          )}
          {!lsStape && isArray && <HousesList housesData={houseData} />}
          <Form>
            {lsStape ? (
              <div style={{ width: '100%' }}>
                <div className={styles.register}>
                  Выберите доступные типы ЛС, по которым возможна регистрация:
                </div>
                {/*                 
                  // <TypeBlock
                  //   arrearTypes={arrearTypes}
                  //   findAccountTypeNameById={findAccountTypeNameById}
                  //   oversProvider={oversProvider}
                  //   handleAccountTypeChange={handleAccountTypeChange}
                  //   handleProviderChange={handleProviderChange}
                  //   arrearProviders={arrearProviders}
                  //   accountTypeIds={accountTypeIds}
                  // /> */}
                {
                  <Checkbox.Group
                    style={{ width: '100%' }}
                    onChange={handleLsTypesChange}
                    value={lsTypesSelected}
                  >
                    <div className={styles.checkboxWrapper}>
                      {accountTypes.map((type) => (
                        <div
                          className={styles.checkboxCard}
                          key={type.id}
                          style={{ height: '60px', minHeight: '60px' }}
                        >
                          <div className={styles.cardContent}>
                            <div className={styles.title}>{type.name}</div>
                            <div className={styles.subtitle}>
                              {getDeterminingNumberHouses(type.id)}
                            </div>
                          </div>
                          <Checkbox
                            className={styles.customCheckboxReg}
                            value={type.id}
                          />
                        </div>
                      ))}
                    </div>
                  </Checkbox.Group>
                }
              </div>
            ) : (
              <>
                <div className={styles.groupSelect}>
                  <div className={styles.register}>Режим регистрации</div>
                  <Item style={{ margin: '0', width: 'auto' }}>
                    {getFieldDecorator('type', {
                      initialValue: stateType.id,
                      rules: [
                        {
                          required: true,
                          message: 'Выберите режим регистрации',
                        },
                      ],
                    })(
                      <Select
                        onChange={handleChangeType}
                        className={styles.selectRegistration}
                      >
                        {types &&
                          types.map((type) => {
                            return (
                              <Option
                                key={type.id}
                                value={type.id}
                              >
                                {type.name}
                              </Option>
                            );
                          })}
                      </Select>
                    )}
                  </Item>
                </div>
                <Item>
                  {getFieldDecorator('check', {
                    initialValue: false,
                  })(
                    <Checkbox
                      className={styles.customCheckbox}
                      onChange={handleCheckboxChange}
                    >
                      <span style={checkBosStyle}>
                        Подтверждаю необходимость изменения режима регистрации
                        для данного адреса
                      </span>
                    </Checkbox>
                  )}
                </Item>
                {stateType.id !== registrationTypes.closed.id ? (
                  ''
                ) : (
                  <div className={styles.infoBlock}>
                    <Icon
                      style={{ color: '#0995ED' }}
                      type="info-circle"
                    />
                    <div className={styles.infoText}>
                      После изменения режима регистрации вам нужно будет выбрать
                      существующее информационное сообщение или создать новое.
                    </div>
                  </div>
                )}
              </>
            )}
          </Form>
        </>
      )}
    </DspxModal>
  );
};

const TemplateModal = Form.create({ name: 'template_form_modal' })(
  TemplateFormModal
);

export default TemplateModal;
